// gkc_hash_code : 01E7J1BV41XHVJMHH8Y4PHXG7H
export const TEST_ACTION = {
  JOIN_TEST: 'STUDENT/TEST_ACTION/JOIN_TEST',
  SUBMIT_TEST_ANSWERS: 'STUDENT/TEST_ACTION/SUBMIT_TEST_ANSWERS',
  GET_FILE_DOWNLOAD_URL: 'STUDENT/TEST_ACTION/GET_FILE_DOWNLOAD_URL',
  GET_TEST_RESULTS: 'STUDENT/TEST_ACTION/GET_TEST_RESULTS',
  UPLOAD_FILE_ANSWER: 'STUDENT/TEST_ACTION/UPLOAD_FILE_ANSWER',
  GET_DETAILS_QUESTION: 'STUDENT/TEST_ACTION/GET_DETAILS_QUESTION'
};
